import { render, staticRenderFns } from "./VideoWidget.vue?vue&type=template&id=7d35f882&"
import script from "./VideoWidget.vue?vue&type=script&lang=js&"
export * from "./VideoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d35f882')) {
      api.createRecord('7d35f882', component.options)
    } else {
      api.reload('7d35f882', component.options)
    }
    module.hot.accept("./VideoWidget.vue?vue&type=template&id=7d35f882&", function () {
      api.rerender('7d35f882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/VideoWidget.vue"
export default component.exports